var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7526 3.02559C12.6634 2.96494 12.5601 2.92852 12.4526 2.91994C12.3452 2.91136 12.2373 2.9309 12.1397 2.97664L1.60552 7.9339C1.49784 7.98464 1.40706 8.06533 1.34402 8.1663C1.28098 8.26728 1.24836 8.38427 1.25006 8.50329C1.25176 8.62232 1.28771 8.73833 1.3536 8.83747C1.4195 8.9366 1.51255 9.01466 1.62163 9.0623L4.96779 10.5266V14.6919L8.58411 12.1092L11.5362 13.4005C11.6273 13.4404 11.7267 13.4578 11.826 13.4512C11.9253 13.4446 12.0215 13.4142 12.1065 13.3625C12.1915 13.3108 12.2629 13.2395 12.3145 13.1544C12.3661 13.0693 12.3965 12.9731 12.4031 12.8738L13.0227 3.57895C13.0295 3.47121 13.0082 3.36355 12.9608 3.26654C12.9135 3.16953 12.8417 3.0865 12.7526 3.02559ZM11.2245 11.9115L7.9595 10.4826L9.92505 6.63634L5.18529 9.26989L3.36845 8.47487L11.7159 4.54623L11.2245 11.9115Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPaperPlane);
export default __webpack_public_path__ + "static/media/bx-paper-plane.8bf70e17fe70418d79db4e43076c339b.svg";
export { ForwardRef as ReactComponent };